import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import AjustesMenu from '../components/AjustesMenu'; // O '../components/AjustesMenu' según la ruta real


const BASE_URL = 'https://mundiemby.us.to';
const AVATARES_POR_PAGINA = 24;

function EditarPerfil() {
  const navigate = useNavigate();
  const perfilGuardado = JSON.parse(localStorage.getItem('perfilActual'));
  const [perfil, setPerfil] = useState({
    nombre: '',
    telefono: '',
    telegram: '',
    email: '',
    avatar: 'default.png',
    pin: null,
    es_admin: false
  });
  const [password, setPassword] = useState('');
  const [avatares, setAvatares] = useState([]);
  const [pagina, setPagina] = useState(0);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    if (!perfilGuardado || !perfilGuardado.id) {
      navigate('/SeleccionarPerfil');
    } else {
      api.get(`/perfiles/detalle/${perfilGuardado.id}`)
        .then((res) => {
          const { nombre, telefono, telegram, email, avatar, pin, es_admin } = res.data;
          setPerfil({
            nombre,
            telefono: telefono || '',
            telegram: telegram || '',
            email: email || '',
            avatar: avatar || 'default.png',
            pin: pin || null,
            es_admin: es_admin || false
          });
        })
        .catch(() => setError('Error al cargar los datos del perfil'));
    }

    fetch(`${BASE_URL}/api/avatars`)
      .then((res) => res.json())
      .then((data) => setAvatares(data))
      .catch(() => {
        setAvatares(['default.png']);
        setError('No se pudieron cargar los avatares disponibles');
      });
  }, []);

  const handleChange = (e) => {
    setPerfil({ ...perfil, [e.target.name]: e.target.value });
  };

  const seleccionarAvatar = (nuevoAvatar) => {
    setPerfil((prev) => ({ ...prev, avatar: nuevoAvatar }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/perfiles/${perfilGuardado.id}`, {
        ...perfil,
        password: perfil.es_admin && password ? password : undefined
      });
      const actualizado = { ...perfilGuardado, ...perfil };
      localStorage.setItem('perfilActual', JSON.stringify(actualizado));
      setMensaje('Perfil actualizado correctamente');
      setPassword('');
    } catch {
      setError('Error al actualizar el perfil');
    }
  };

  const handleVolver = () => {
    navigate(-1);
  };

  const totalPaginas = Math.ceil(avatares.length / AVATARES_POR_PAGINA);
  const avataresPagina = avatares.slice(
    pagina * AVATARES_POR_PAGINA,
    (pagina + 1) * AVATARES_POR_PAGINA
  );

  return (
    <div style={styles.container}>
      <AjustesMenu />
      <button onClick={handleVolver} style={styles.volverMejorado}>Volver</button>
      <h2>Editar Perfil</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          name="nombre"
          placeholder="Nombre"
          value={perfil.nombre}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="text"
          name="telefono"
          placeholder="Teléfono"
          value={perfil.telefono}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="text"
          name="telegram"
          placeholder="Telegram"
          value={perfil.telegram}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={perfil.email}
          onChange={handleChange}
          style={styles.input}
        />

        {perfil.es_admin && (
          <input
            type="password"
            name="password"
            placeholder="Nueva contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
        )}

        <label style={styles.label}>Selecciona tu avatar</label>

        <div style={styles.paginationButtons}>
          <button
            type="button"
            onClick={() => setPagina(p => Math.max(p - 1, 0))}
            disabled={pagina === 0}
            style={styles.pageButton}
          >
            «
          </button>
          <span style={styles.pageIndicator}>Página {pagina + 1} de {totalPaginas}</span>
          <button
            type="button"
            onClick={() => setPagina(p => Math.min(p + 1, totalPaginas - 1))}
            disabled={pagina >= totalPaginas - 1}
            style={styles.pageButton}
          >
            »
          </button>
        </div>

        <div style={styles.avatarGrid}>
          {avataresPagina.map((avatar) => (
            <img
              key={avatar}
              src={`${BASE_URL}/avatars/${avatar}`}
              alt={avatar}
              onClick={() => seleccionarAvatar(avatar)}
              style={{
                ...styles.avatarMiniatura,
                border: perfil.avatar === avatar ? '3px solid white' : '1px solid #333'
              }}
            />
          ))}
        </div>

        <img
          src={`${BASE_URL}/avatars/${perfil.avatar}`}
          alt="Vista previa"
          style={styles.avatarPreview}
        />

        {error && <p style={styles.error}>{error}</p>}
        {mensaje && <p style={styles.success}>{mensaje}</p>}
        <button type="submit" style={styles.button}>Guardar Cambios</button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    minHeight: '100vh'
  },
  form: {
    maxWidth: '650px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  input: {
    padding: '0.6rem',
    fontSize: '1.2rem',
    borderRadius: '8px',
    border: '1px solid #555',
    background: '#111',
    color: 'white',
    textAlign: 'center'
  },
  label: {
    fontSize: '1rem',
    color: 'white',
    marginBottom: '0.3rem'
  },
  avatarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
    gap: '10px',
    justifyItems: 'center',
    marginTop: '10px',
    marginBottom: '10px'
  },
  avatarMiniatura: {
    width: '60px',
    height: '60px',
    borderRadius: '10px',
    objectFit: 'cover',
    cursor: 'pointer'
  },
  avatarPreview: {
    marginTop: '15px',
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '10px',
    border: '2px solid white',
    alignSelf: 'center'
  },
  button: {
    padding: '0.8rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  volverMejorado: {
    position: 'absolute',
    top: '0.5rem',
    left: '0.5rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '0.3rem 0.5rem',
    fontSize: '1.3rem',
    cursor: 'pointer',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    width: 'fit-content'
  },
  error: {
    color: 'red'
  },
  success: {
    color: 'lime'
  },
  paginationButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '10px'
  },
  pageButton: {
    background: '#222',
    color: 'white',
    border: '1px solid #666',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  pageIndicator: {
    fontSize: '0.9rem',
    color: '#ccc'
  }
};

export default EditarPerfil;
